var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWallet = function SvgWallet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Wallet_svg__a)",
    fillRule: "evenodd",
    d: "M20 6H2.25a.75.75 0 0 1 0-1.5H16.5a.75.75 0 0 0 0-1.5H2a2 2 0 0 0-2 2v13a4 4 0 0 0 4 4h16a4 4 0 0 0 4-4v-8a4 4 0 0 0-4-4m0 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
    clipRule: "evenodd"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Wallet_svg__a",
    x1: 15.986,
    x2: -0.099,
    y1: 24.252,
    y2: -11.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44BCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.379,
    stopColor: "#7298F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A099FF"
  })))));
};
export default SvgWallet;